import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/claim.ts
const claimInfoSchema = z.object({
	id: z.string(),
	amount: z.number().int(),
	canClaim: z.boolean(),
	claimedAt: z.number().int().nullable(),
	nextClaimableTime: z.number().int().nullable(),
	emailVerificationRequiredSince: z.number().int().nullable().meta({ description: "The time when the user needs to verify their email, in milliseconds since unix epoch; if in the past, the user needs to verify their email; if in the future, the user needs to finish the verification process before that; if not present the user does not need to verify their email or is already verified" })
});
const claimIdInputSchema = z.object({ id: z.string() });
const unauthorizedError = { UNAUTHORIZED: {
	status: 401,
	message: "Authentication required"
} };
const notFoundError = { NOT_FOUND: {
	status: 404,
	message: "Claim type not found"
} };
const claimContract = oc.prefix("/claim").tag("Claim").router({
	list: oc.route({
		summary: "List all claimable rewards",
		description: "Returns all available claim types with their current status for the authenticated user.",
		method: "GET",
		path: "/"
	}).output(z.array(claimInfoSchema)).errors(unauthorizedError),
	get: oc.route({
		summary: "Get claim info by id",
		description: "Returns the claim status for a specific claim type (e.g., pixai-daily-credits, agent-stamina-daily).",
		method: "GET",
		path: "/{id}"
	}).input(claimIdInputSchema).output(claimInfoSchema).errors({
		...unauthorizedError,
		...notFoundError
	}),
	claim: oc.route({
		summary: "Claim a reward",
		description: "Claims the specified reward if available. Returns the updated claim status after claiming.",
		method: "POST",
		path: "/{id}"
	}).input(claimIdInputSchema).output(claimInfoSchema).errors({
		...unauthorizedError,
		...notFoundError
	})
});
//#endregion
export { claimContract, claimInfoSchema };
